export default __webpack_public_path__ + "static/BOQ-e598f18b2ae25fe9c12c92f95b1e20ac.png";